import React, { useMemo } from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import NavigationButtons from '../components/NavigationButtons';
import './OnboardingSummary.css';

// Les dates de cycle sont stockées en ISO (input type="date") mais affichées
// au format français, comme le reste du récapitulatif.
const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return y && m && d ? `${d}/${m}/${y}` : '';
};

const OnboardingSummary = () => {
  const { formData } = useOnboarding();

  const age = useMemo(() => {
    if (!formData.birthDate) return '';
    const parts = formData.birthDate.split('/');
    if (parts.length !== 3) return '';
    const birth = new Date(parts[2], parts[1] - 1, parts[0]);
    const today = new Date();
    let years = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      years--;
    }
    return `${years} ans`;
  }, [formData.birthDate]);

  const infoItems = [
    { label: 'Prénom', value: formData.firstName },
    { label: 'Âge', value: age },
    { label: 'Taille', value: formData.height ? `${formData.height} cm` : '' },
    { label: 'Poids', value: formData.weight ? `${formData.weight} kg` : '' },
    { label: 'Sport', value: formData.sport?.length ? formData.sport.join(', ') : '' },
    { label: 'Niveau', value: formData.level },
    { label: 'Dernières règles', value: formatDate(formData.lastPeriodDate) },
    { label: 'Dernière ovulation', value: formatDate(formData.lastOvulationDate) },
  ];

  return (
    <PageLayout step={7}>
      <h2 className="title">
        Parfait{formData.firstName ? ` ${formData.firstName}` : ''} !
      </h2>
      <p className="subtitle">
        Nous avons bien enregistré vos informations. Vous êtes prête à commencer
        votre suivi personnalisé.
      </p>

      <div className="summary-card">
        {infoItems.map((item) => (
          <div key={item.label} className="summary-card__item">
            <span className="summary-card__label">{item.label}</span>
            <span className="summary-card__value">{item.value || '—'}</span>
          </div>
        ))}
      </div>

      <NavigationButtons
        nextPath="/onboarding/notifications"
        prevPath="/onboarding/cycle"
      />
    </PageLayout>
  );
};

export default OnboardingSummary;
